import { useAsyncCallback } from 'react-async-hook';
import { useInviteStore } from '../store/use-invite-store';
import { useUploadBusyStore } from '../store/use-upload-busy-store';
import { api } from './instance';

export function useAttachmentDelete() {
  const { invite, removeAttachment } = useInviteStore();

  const start = useUploadBusyStore((s) => s.start);
  const stop = useUploadBusyStore((s) => s.stop);

  return useAsyncCallback(async (attachmentId) => {
    if (!attachmentId) return true;

    start();
    try {
      await api.auth.delete(`attachment/${attachmentId}/${invite.id}`);
      removeAttachment(attachmentId);
    } catch (e) {
      // TODO: user feedback
      console.error('Failed to delete attachment:', e);
    } finally {
      stop();
    }
  });
}
